import React from "react";
import Slider from "react-slick";
import { Headernew } from "./Headernew";
export const AboutHome = () => {
  var settings_2 = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 1000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Headernew />
      <section className="d-block chosse_banner">
        <div className="clip_left"></div>
        <div className="clip_right"></div>
        <div className="d-flex flex-column justify-content-center position-relative align-items-center h-100">
          <h3>About us</h3>
        </div>
      </section>
      <section className="d-block about_sec py-5">
        <div className="container-xl">
          <div className="row gy-5 justify-content-between align-items-center">
            <div className="col-lg-7">
              <div className="d-flex flex-column gap-3">
                <p>
                  At JL Mining, we’re more than just a workforce provider, we’re
                  the connection point between skilled tradespeople, top-tier
                  mining clients, and reliable subcontractors across Western
                  Australia.
                </p>
                <p>
                  With deep roots in the mining and construction sectors, our
                  team brings real, boots-on-theground experience to every
                  project. Whether it’s high-voltage electrical, hydraulic
                  repair, civil construction, or labour hire, we deliver expert
                  solutions that keep WA’s mining industry moving.
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="about1_img">
                <img
                  className="w-100 h-100"
                  src={require("./assets/images/about1.png")}
                  alt="Logo"
                />
              </div>
            </div>
            <div className="col-12">
              <p className="text-center">
                Through our two specialised divisions, JL Mining and JL Mining
                Electrical, we offer flexible, safety-focused services that
                match the pace and pressure of the mining world. From urgent
                labour needs to long-term partnerships, we have the people, the
                systems, and the drive to get it done, on time, and to the
                highest standard
              </p>
            </div>
            <div className="col-lg-5">
              <div className="about1_img">
                <img
                  className="w-100 h-100"
                  src={require("./assets/images/about2.png")}
                  alt="Logo"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="d-flex flex-column gap-3">
                <p>
                  We’re also building the future of mining careers, giving
                  tradespeople and subcontractors direct access to real
                  opportunities across the state. If you're ready to grow your
                  team, land your next contract, or start a new role in the
                  industry, you’re in the right place
                </p>
              </div>
            </div>
            <div className="col-lg-4 d-md-block d-none"></div>
            <div className="col-lg-8">
              <div className=" margiin_abouttop">
                <img
                  className="w-100 h-100"
                  src={require("./assets/images/about3.png")}
                  alt="Logo"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="company_overview d-block pb-5">
        <div className="container-xl">
          <div className="row gy-4 justify-content-center align-items-center text-center">
            <div className="col-12">
              <h3>Company Overview</h3>
            </div>
            <div className="col-12">
              <div className="d-flex flex-column gap-4">
                <p>
                  JL Holdings Pty Ltd, trading as JL Mining and JL Mining
                  Electrical, is a trusted provider of maintenance, labour hire,
                  and electrical services across Western Australia’s mining and
                  civil construction sectors. With a reputation for safety,
                  quality, and reliability, we’ve built strong partnerships by
                  delivering expert solutions tailored to the high-pressure
                  demands of mining operations.
                </p>
                <p>
                  Our team of skilled professionals offers hands-on experience
                  across hydraulic systems, light and heavy vehicle repairs,
                  high-voltage electrical, and construction projects. From our
                  bases in East Bunbury and Henderson, we serve Tier-1 clients,
                  subcontractors, and job seekers with the same commitment: to
                  keep the wheels of WA’s mining industry turning, safely and
                  efficiently.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our_parpose d-block">
        <div className="container-xl">
          <div className="row our_parpose_main">
            <div className="col-lg-3 position-relative">
              <div className="purpose_img">
                <img
                  className="w-100 h-100"
                  src={require("./assets/images/about4.png")}
                  alt="Logo"
                />
              </div>
            </div>
            <div className="col-lg-8 mx-auto">
              <div className="d-flex flex-column gap-4 py-5">
                <h4 className="pb-3">Our Purpose</h4>
                <p>
                  At JL Mining, our purpose is simple, to connect the right
                  people with the right opportunities in the mining and civil
                  sectors.
                </p>
                <p>
                  Whether you’re a tradesperson looking to build your career, a
                  subcontractor searching for reliable work, or a company
                  needing skilled support, we make it easier to get where you
                  need to be. Backed by experience, powered by people, and
                  driven by safety, we’re here to support your success in one of
                  the toughest and most rewarding industries in Australia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="industries d-block py-5">
        <div className="container-xl">
          <div className="row gy-5">
            <div className="col-12">
              <div className="d-flex flex-column gap-3 text-center">
                <h3>Industries We Serve</h3>
                <p>
                  We’re proud to support a broad range of industries across
                  Western Australia, including:
                </p>
              </div>
            </div>
            <div className="col-lg-9 mx-auto">
              <div className="row gy-5">
                <div className="col-lg-6">
                  <div className="d-flex align-items-center gap-3">
                    <div className="ixcon_indu">
                      <img
                        className="w-100 h-100"
                        src={require("./assets/images/8277733.png")}
                        alt="Logo"
                      />
                    </div>
                    <p>
                      <strong>Mining (underground & surface)</strong>
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex align-items-center gap-3">
                    <div className="ixcon_indu">
                      <img
                        className="w-100 h-100"
                        src={require("./assets/images/5257214.png")}
                        alt="Logo"
                      />
                    </div>
                    <p>
                      <strong>Water & Utilities</strong>
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex align-items-center  gap-3">
                    <div className="ixcon_indu">
                      <img
                        className="w-100 h-100"
                        src={require("./assets/images/17041574.png")}
                        alt="Logo"
                      />
                    </div>
                    <p>
                      <strong>Oil, Gas & Energy</strong>
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex align-items-center gap-3">
                    <div className="ixcon_indu">
                      <img
                        className="w-100 h-100"
                        src={require("./assets/images/12204932.png")}
                        alt="Logo"
                      />
                    </div>
                    <p>
                      <strong>Civil Construction</strong>
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex align-items-center  gap-3">
                    <div className="ixcon_indu">
                      <img
                        className="w-100 h-100"
                        src={require("./assets/images/6983490.png")}
                        alt="Logo"
                      />
                    </div>
                    <p>
                      <strong>Rail & Transport</strong>
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex align-items-center gap-3">
                    <div className="ixcon_indu">
                      <img
                        className="w-100 h-100"
                        src={require("./assets/images/18278654.png")}
                        alt="Logo"
                      />
                    </div>
                    <p>
                      <strong>Government Projects</strong>
                    </p>
                  </div>
                </div>
                <div className="col-12">
                  <p className="text-start">
                    Whether it’s a shutdown, a start-up, or an ongoing
                    operation, JL Mining has the personnel, equipment, and
                    know-how to deliver results, safely, on time, and on budget.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="d-block py-5 our-partner1">
        <div className="container-lg">
          <div className="d-flex flex-column gap-2 pb-3">
            <h4>Our Trusted Partners</h4>
            <p>
              We deliver great results and we have cultivated long-term
              relationships with leading brands and companies.
            </p>
          </div>
          <Slider {...settings_2} className="logo-slider ">
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-hss.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-bird.webp")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/jl-logo.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-hunta.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img-h d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-minotaur.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-walc.png")}
                alt="logo"
              />
            </div>
          </Slider>
        </div>
      </section>
      <section className="d-block  get_intouch">
        <div className="d-flex flex-column justify-content-center align-items-center gap-3 py-4 bg-get_intouch text-center">
          <h4>
            Staffing Excellence for a<br />
            <span>Brighter Future</span>
          </h4>
          <a href="#">Get In Touch</a>
          <div className="clip_left"></div>
          <div className="clip_right"></div>
        </div>
      </section>
    </div>
  );
};
